import { createContext, useContext, type ReactNode } from 'react';

type NavItemPopoverConfig = {
  content: ReactNode;
  isOpen: boolean;
};

type NavItemPopoverContextType = {
  popovers: Record<string, NavItemPopoverConfig>;
};

export const NavItemPopoverContext = createContext<NavItemPopoverContextType | null>(null);

export const NavItemPopoverProvider = ({
  children,
  popovers,
}: {
  children: ReactNode;
  popovers?: Record<string, NavItemPopoverConfig>;
}) => {
  const contextValue = { popovers: popovers ?? {} };

  return <NavItemPopoverContext.Provider value={contextValue}>{children}</NavItemPopoverContext.Provider>;
};

export const useNavItemPopover = () => {
  const context = useContext(NavItemPopoverContext);
  if (!context) {
    throw new Error('useNavItemPopover must be used within NavItemPopoverProvider');
  }
  return context;
};
